<template>
  <div
    id="menu-global-avatar"
    :data-cy="dataCy"
    :class="`global-avatar ${className || ''} ${
      isRectangle && !!src
        ? '!tw-rounded-none'
        : isRectangle && !src
          ? '!tw-w-[39px]'
          : ''
    }`"
    :style="`background-color: ${avatarBgColor}`"
  >
    <img
      v-if="!!src"
      alt="avatar"
      :src="src"
      :class="`${imgClassName} ${isRectangle ? '!tw-rounded-none' : ''}`"
    />
    <span v-else :style="`font-size:${fontSize}; font-weight: ${fontWeight}`">{{
      letterName.toUpperCase()
    }}</span>
  </div>
</template>

<script setup lang="ts">
import { getDefaultBackgroundColor } from "@/utils/utilities";
import { computed } from "vue";

const props = defineProps<{
  src?: string;
  name?: string;
  className?: string;
  fontSize?: string;
  fontWeight?: string;
  isRectangle?: boolean;
  imgClassName?: string;
  dataCy?: string;
}>();

const avatarBgColor = computed(() => {
  if (props.src) {
    return "unset";
  }
  return getDefaultBackgroundColor(props.name || "");
});

const letterName = computed(() => {
  const arr = `${props.name?.trim() || ""}`.split(" ").filter(Boolean);
  if (arr.length === 0) return "";

  if (props.isRectangle) {
    return `${arr[0]?.[0] || ""}${arr.length > 1 ? arr[1]?.[0] || "" : ""}`;
  }

  return `${arr[0]?.[0] || ""}${
    arr.length > 1 ? arr[1]?.[0] || arr[0]?.[1] || "" : arr[0]?.[1] || ""
  }`;
});
</script>

<style lang="scss" scoped>
.global-avatar {
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 50%;
  line-height: normal;
  overflow: hidden;
  width: 32px;
  height: 32px;
  & > span {
    color: #fff;
    font-size: 10px;
    line-height: normal;
  }
  & > img {
    width: 100%;
    height: 100%;
    border-radius: 50%;
  }
}
.parent-share-avatar {
  width: 100%;
  height: 39px;
}
</style>
